<rid-mechanic-background />

<rid-mechanic-wrapper>
  <rid-top-bar class="block w-full" [name]="name()" [steps]="prompts().length" [progress]="progress()" />

  <rid-mechanic-content>
    <div class="grid justify-items-center gap-4">
      <div class="relative min-h-58 w-full">
        @for (input of [prompt()]; track input) {
          <div class="absolute bottom-0 grid w-full justify-items-center gap-4" animate.leave="anim-fade-out">
            <rid-option
              #option
              animate.enter="wait-500 anim-pop-in"
              [option]="input.prompt"
              (animationend)="$event.animationName === 'pop-in' ? option.present() : undefined"
            />
            <rid-text-input class="w-full" animate.enter="wait-750 anim-pop-in" [appearance]="appearance()">
              <div class="flex place-self-center">
                <rid-vertical-spacer>
                  <rid-compressable-klank-card content="x" />
                </rid-vertical-spacer>

                @for (k of keyboardComp.content(); track $index) {
                  <rid-syllabic-card [value]="k" animate.enter="anim-pop-in" />
                }
                @for (k of keyboardComp.postfix(); track $index) {
                  <rid-syllabic-card [value]="k" animate.enter="anim-fade-in" />
                }
              </div>
            </rid-text-input>
          </div>
        }
      </div>
      <rid-functional-syllabic-keyboard
        #keyboardComp
        [layout]="layout()"
        [mask]="mask()"
        [mode]="mode()"
        [validate]="validate.bind(this)"
        [correctValue]="prompt().answer[promptKlankIndex()]"
        (inserted)="onInsert($event)"
        (incorrected)="onIncorrect()"
        (appliedRule)="onApplyRule($event)"
      />
    </div>

    <!-- reveal -->
    @if (revelation(); as revelation) {
      <rid-modal-background [blur]="true" />
      <rid-correct-answer-modal (continue)="revealWaiter.finish()">
        <h3 class="font-family-din mb-4 text-lg">Het goede antwoord is:</h3>
        <div class="rounded-md border-3 border-dashed border-slate-300">
          <div class="flex scale-75 place-self-center">
            @for (k of revelation; track $index) {
              <rid-syllabic-card [value]="k" />
            }
          </div>
        </div>
      </rid-correct-answer-modal>
    }

    <!-- feedback overlay -->
    <rid-overlay-feedback #overlayFeedback />
  </rid-mechanic-content>
</rid-mechanic-wrapper>
